import ListingsRoutingResolver from './ListingRoutingResolver';

export class InvoiceListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "invoice"
    }
}


export class InvoiceDraftListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "invoicedraft"
    }
}

export class EstimateListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "estimate"
    }
}

export class CreditnoteListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "creditnote"
    }
}

export class CreditnotedraftListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "creditnotedraft"
    }
}

export class OrderListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "order"
    }
}

export class DeliveryListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "delivery"
    }
}

export class ProformaListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "proforma"
    }
}

